export default __webpack_public_path__ + "static/premioBCL-51382c54e1bafc5b201885daf6763a81.png";